/**
 * Misafir uygulamasındaki TÜM yol string'leri — TEK kaynak.
 *
 * `` <AppLink to={`/${slug}/rsvp`}> `` yerine `<AppLink to={paths.wedding.rsvp(slug)}>`;
 * yeniden adlandırma tek satır kalır.
 *
 * Her girdi `toRoutePath()`'ten geçer → `RoutePath` markası taşır. Sarmalayıcılar
 * (`lib/route-primitives.tsx`) yalnız `RoutePath` kabul ettiği için elle yazılmış
 * bir rota string'i DERLENMEZ; `pnpm check:routes` (CI gate) ikinci savunma hattı.
 *
 * ⚠️ Buradaki segmentler `App.tsx`'teki `<Route path=...>` segmentleriyle ELLE
 * senkron tutulmaz artık: `lib/wedding-routes.ts` (WEB_WEDDING_ROUTES) tek kaynak,
 * `App.tsx` oradan türer. Senkronu `src/__tests__/route-resolution.test.tsx` kanıtlar.
 */
import { WEB_PRIVACY_PATH, WEB_TERMS_PATH, toRoutePath, type RoutePath } from "@wedding/shared";

export const paths = {
  /** Pazarlama sitesi (kök). */
  landing: toRoutePath("/"),
  /** KVKK aydınlatma metni — `privacy` `RESERVED_SLUGS`'ta, hiçbir düğün bu adı alamaz. */
  privacy: toRoutePath(WEB_PRIVACY_PATH),
  /** Kullanım koşulları — `terms` da `RESERVED_SLUGS`'ta. */
  terms: toRoutePath(WEB_TERMS_PATH),
  /** Online satın alma (F8b) — `checkout` `RESERVED_SLUGS`'ta. `plan` ön seçim için. */
  checkout: (plan?: "pro" | "max"): RoutePath => toRoutePath(plan ? `/checkout?plan=${plan}` : "/checkout"),
  /** Join tema demo sayfası — düğün/auth context'i gerektirmez. */
  demo: (id: string): RoutePath => toRoutePath(`/demo/${id}`),
  wedding: {
    home: (slug: string): RoutePath => toRoutePath(`/${slug}`),
    auth: (slug: string): RoutePath => toRoutePath(`/${slug}/auth`),
    /**
     * QR katılım sayfası. Bugün `navigate()` ile kullanılmıyor — QR akışı
     * `buildScanUrl`/`buildJoinUrl` ile AYRI bir dış URL üretiyor — ama
     * `App.tsx`'in segmentiyle eşleşsin diye burada duruyor.
     */
    join: (slug: string): RoutePath => toRoutePath(`/${slug}/join`),
    rsvp: (slug: string): RoutePath => toRoutePath(`/${slug}/rsvp`),
    gallery: (slug: string): RoutePath => toRoutePath(`/${slug}/gallery`),
    upload: (slug: string): RoutePath => toRoutePath(`/${slug}/upload`),
    slideshow: (slug: string): RoutePath => toRoutePath(`/${slug}/slideshow`),
  },
} as const;
